<template>
	<main>
		<h1>Commands</h1>

		<form>
			<BaseFormComponent id="command_api_token" label="Select API token">
				<BaseSelect v-model="apiToken" id="command_api_token">
					<option value="">No token selected</option>
					<option
						v-for="apiTokenOption in apiTokens"
						:key="apiTokenOption.id"
						:value="apiTokenOption.id"
					>
						{{ apiTokenOption.name }}
					</option>
				</BaseSelect>
			</BaseFormComponent>
		</form>

		<template v-if="apiToken">
			<AddCommandForm
				:api-token="apiToken"
				:copy-command="commandToReplay"
				@commandAdded="onCommandAdded"
			/>
			<CommandsList
				:commands="commands"
				@requestDelete="deleteCommand"
				@requestReplay="replayCommand"
				@requestAnswerPages="fetchAnswerPages"
			/>
		</template>
	</main>
</template>

<script>
import { getErrors } from '@/core/http'
import AddCommandForm from '../components/AddCommandForm'
import CommandsList from '../components/CommandsList'
import commandsHttp from '../commandsHttp'
import BaseFormComponent from '@/core/components/BaseFormComponent'
import BaseSelect from '@/core/components/BaseSelect'
import apiTokensHttp from '@/modules/api_token/apiTokensHttp'
import deleteMixin from '@/modules/command/deleteMixin'
import replayMixin from '@/modules/command/replayMixin'

export default {
	name: 'Command',
	mixins: [
		deleteMixin,
		replayMixin,
	],
	components: {
		BaseSelect,
		BaseFormComponent,
		AddCommandForm,
		CommandsList,
	},
	data() {
		return {
			apiToken: this.$route.params.apiTokenId || '',
			apiTokens: [],
			commands: [],
			reloadTimer: null,
		};
	},
	watch: {
		'$route.params.apiTokenId'(newValue) {
			this.apiToken = newValue;

			if (newValue === '') {
				this.commands = [];

				return;
			}

			this.fetchCommands();
		},
		apiToken(newValue) {
			this.$router.push(`/command/${newValue}`);
		},
	},
	created() {
		this.fetchCommands()
			.catch(response => {
				const errors = getErrors(response);

				errors.forEach((text) => {
					this.$flashMessage.show({
						type: 'error',
						text,
					});
				});
			})
		;

		this.fetchApiTokens()
			.catch(e => void e)
		;
	},
	mounted() {
		this.reloadTimer = setInterval(this.fetchUnansweredCommands.bind(this), 15000);
	},
	unmounted() {
		clearInterval(this.reloadTimer);
	},
	methods: {
		async fetchCommands() {
			if (!this.apiToken) {
				return;
			}

			/** @var {Array|Object} commands */
			const commands = await commandsHttp.getAll({
				api_token: this.apiToken,
			});

			this.commands = commands.reverse();
		},
		fetchUnansweredCommands() {
			if (!this.apiToken) {
				return;
			}

			/** @var {Array|Object} commands */
			this.commands.forEach((command, index) => {
				if (!command.answer) {
					commandsHttp.get(command.id)
						.then(command => {
							this.commands.splice(index, 1, command)
						})
					;
				}
			});
		},
		async fetchApiTokens() {
			this.apiTokens = await apiTokensHttp.getAll();
		},
		onCommandAdded(newCommand) {
			this.commands.unshift(newCommand);
		},
		async fetchAnswerPages(command) {
			let answer = [];

			for (let i = 1; i <= command.count_answer_pages; i++) {
				answer = answer.concat(await commandsHttp.getAnswerPage(command.id, i));
			}

			command.answer = answer;
		},
	},
};
</script>

<style scoped>
main {
	display: grid;
	grid-template-columns: 1fr 1fr;
}
</style>
